import { useState, FC, useMemo, useEffect } from "react";
import styles from "./style.module.css";
import CategoryTabs from "./components/CategoryTabs";
import clsx from "clsx";
import { Col, Pagination, Row, Space, Typography } from "antd";
import BlogCard from "./components/BlogCard";
import BigBlogCard from "./components/BigBlogCard";
import { useListBlog } from "api/blog";

const pageSize = 7;

const Blog: FC = () => {
  const [page, setPage] = useState<number>(1);
  const [category, setCategory] = useState<string>("");
  const { data: blogRes } = useListBlog({
    pageSize,
    page,
    categories: category === "" ? [] : [category],
  });

  const totalItems = blogRes?.pages[0]?.pagedResult?.totalItems || 0;
  const blogList = blogRes?.pages[0]?.pagedResult?.items || [];

  const outstandingPost = blogList[0];
  const displayPosts = useMemo(() => {
    const temp = [...blogList];
    temp.shift();
    return temp;
  }, [blogList]);

  const onChangeCategory = (value: string | "") => {
    setPage(1);
    setCategory(value);
  };

  useEffect(() => window.scrollTo(0, 0), [blogRes]);

  return (
    <div className={clsx(styles.root)}>
      <Space
        direction="horizontal"
        align="center"
        style={{ margin: "0 auto 32px" }}
      >
        <div className={styles.blogTitle}>Blog</div>
        <img src="/images/icon/blog.icon.svg" />
      </Space>
      <h1 className={styles.title}>News and insights</h1>
      <Typography style={{ textAlign: "center" }}>
        Learn more about Web3 projects, blockchains, open
        <br />
        opportunities, Web3 Grants, and BuidlFi updates.
      </Typography>
      <CategoryTabs value={category} onChange={onChangeCategory} />
      <div style={{ marginTop: 40 }}>
        <Row gutter={[24, 40]}>
          {!!outstandingPost && (
            <Col span={24}>
              <BigBlogCard data={outstandingPost} />
            </Col>
          )}
          {displayPosts.map((post) => (
            <Col key={post._id} span={8}>
              <BlogCard data={post} />
            </Col>
          ))}
        </Row>
      </div>
      {blogList.length > 0 && (
        <div style={{ marginTop: 48 }}>
          <Pagination
            current={page}
            total={totalItems}
            pageSize={pageSize}
            onChange={(page) => setPage(page)}
          />
        </div>
      )}
    </div>
  );
};

export default Blog;
